var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('RecipeCard',{attrs:{"mobile":[155, 87],"tablet":[328, 185],"desktop":[347, 196],"wide":[424, 240],"model":_vm.model,"size":"large","show-image-load-state":true},nativeOn:{"click":function($event){return _vm.onRecipeClick($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }